import React, { useState } from 'react';
import Modal from 'jd-library/Modal';
import styles from './style.scss';
import ModalIcon from './ModalIcon';


const WalkThroughModal = props => {
    const [btnClicked,updateBtnClicked] = useState(false);
    const [showLoader,toggleLoader] = useState(false);
    return (
        <Modal
            settings={{
                modalId: 'confirm-modal',
                variant: 'action',
            }}
            onHidden={() => {
                if(!btnClicked) {
                    props.skipClick();
                }
                toggleLoader(false)
                props.onHidden();
            }}
            backdropStatic
        >
            <Modal.CloseIcon
                iconClass={'icon-HDRcross'}
            />
            <Modal.Header>
                <div className={styles['modal-hed']}>
                    <ModalIcon />
                    Welcome to Your Catalogue
                </div>
            </Modal.Header>
            <Modal.Body className={styles['modal-bdy']}>
                You are almost ready to update your Catalogue. Watch this short video to learn about all the new features!
            </Modal.Body>
            <Modal.CenterButton
                onClick={() => {
                    toggleLoader(true);
                    updateBtnClicked(true);
                    props.watch()
                }}
                showLoader={showLoader}
            >
                Play video
            </Modal.CenterButton>
        </Modal>
    )
};

export default WalkThroughModal;